var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-operation" },
    [
      _vm.showHistoricalHistory
        ? _c("GreenOperationHistoricalHistory", {
            on: {
              back: function ($event) {
                _vm.showHistoricalHistory = false
              },
            },
          })
        : [
            _c(
              "div",
              { staticClass: "green-operation__actions" },
              [
                _vm.canViewHistoricalRecords
                  ? _c(
                      "a",
                      {
                        staticClass: "green-operation__history-link",
                        on: {
                          click: function ($event) {
                            _vm.showHistoricalHistory = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "tenancy.greenOperation.viewHistoricalHistory"
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("GreenOperationActionBtns"),
              ],
              1
            ),
            _vm._v(" "),
            _c("SppStatusInfo"),
            _vm._v(" "),
            _vm.shouldShowPreviousGreenOperationDisplay
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "HKLCard",
                      {
                        staticClass: "small-6 green-operation__documents",
                        attrs: {
                          title: _vm.$t(
                            "tenancy.greenOperation.tab.sustainabilityDocuments"
                          ),
                        },
                      },
                      [
                        _c("GreenOperationDocuments"),
                        _vm._v(" "),
                        _c("GreenOperationDocumentsHistory"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "HKLCard",
                      {
                        staticClass: "small-6 green-operation__guideline",
                        attrs: {
                          title: _vm.$t("tenancy.greenOperation.tab.guideline"),
                        },
                      },
                      [
                        _c("PostFitOutGuideline", {
                          staticClass: "card-mode",
                          attrs: {
                            guidelines: _vm.publishedGuidelines,
                            expand: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "HKLCard",
                  {
                    attrs: {
                      title: _vm.$t("tenancy.greenOperation.tab.guideline"),
                    },
                  },
                  [
                    _c("PostFitOutGuideline", {
                      staticClass: "card-mode",
                      attrs: {
                        guidelines: _vm.publishedGuidelines,
                        expand: true,
                      },
                    }),
                  ],
                  1
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }